
import src from '@/assets/bg-images/bg-purple.jpg'
export default {
  id: 'bgpurple',
  src,
  width: 1400,
  height: 800,
  color: '#52356f',
  ext: 'jpg'
}
